module.exports = __webpack_public_path__ + "static/media/01.25bebb74.jpg";